import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "seperate-account-flow"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "下单时间", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "订单编号", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "订单所属团队", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "订单状态", -1);

const _hoisted_11 = {
  class: "wrapper"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方类型", -1);

const _hoisted_13 = {
  class: "wrapper"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方", -1);

const _hoisted_15 = {
  class: "wrapper"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算方式", -1);

const _hoisted_17 = {
  class: "wrapper"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算状态", -1);

const _hoisted_19 = {
  class: "wrapper"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_22 = {
  class: "table-toolbox"
};
const _hoisted_23 = {
  class: "left"
};
const _hoisted_24 = {
  class: "wrapper"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账金额统计：", -1);

const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "wrapper"
};

const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "已结算金额统计：", -1);

const _hoisted_29 = {
  class: "value"
};
const _hoisted_30 = {
  class: "right"
};

const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red",
    "margin-right": "10px"
  }
}, "单状态标注“异常”即ERP出库单与订单商品或数量存在差异", -1);

const _hoisted_32 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  key: 0,
  style: {
    "color": "red"
  }
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
import { exportForAsync, getOrderStateList } from '@/request';
import Tool from '@/utils/tool';
import DetailModal from './components/detail-modal.vue';
export default {
  name: 'index',

  setup(__props) {
    const routeQuery = useRoute().query;
    onMounted(() => getSupplierList());
    const now = new Date();
    const lastMonthStartDate = routeQuery.startTime || Tool.formatTime(new Date(now.getFullYear(), now.getMonth() - 1, 1));
    const lastMonthEndDate = routeQuery.endTime || Tool.formatTime(new Date(now.getFullYear(), now.getMonth(), 0));
    const dateRange = ref([lastMonthStartDate, lastMonthEndDate]);
    const search = ref({
      supplierId: '',
      orderCodeSplit: '',
      participateRole: '',
      participateName: routeQuery.participateName || '',
      settlementStatus: '',
      orderStatus: ['40', '6'],
      settlementType: ''
    });
    const statistic = ref({});
    const table = ref();
    const total = ref(0);
    const tableOptions = getVexTableProps({
      columns: [{
        title: '分账流水号',
        field: 'splitSequenceNumber',
        slots: {
          default: 'splitSequenceNumber'
        }
      }, {
        title: '订单编号',
        field: 'orderCodeSplit'
      }, {
        title: '下单时间',
        field: 'orderCreateTime'
      }, {
        title: '分账参与方',
        field: 'participateName'
      }, {
        title: '分账金额',
        field: 'splitAmount'
      }, {
        title: '支付方式',
        field: 'payMethodName'
      }, {
        title: '订单状态',
        field: 'orderStatusName',
        slots: {
          default: 'orderStatusName'
        }
      }, {
        title: '回款状态',
        field: 'repaymentStatusName'
      }, {
        title: '结算状态',
        field: 'settlementStatusName',
        slots: {
          default: 'settlementStatusName'
        }
      }, {
        title: '结算方式',
        field: 'settlementMethodName'
      }, {
        title: '结算时间',
        field: 'lastSettlementTime'
      }, {
        title: '提现状态',
        field: 'withdrawStatusName'
      }, {
        title: '提现时间',
        field: 'withdrawTime'
      }, {
        title: '资金去向账户',
        field: 'accountDestination'
      }, {
        title: '支付流水号',
        field: 'withdrawNo'
      } // { title: '操作', field: 'operation', slots: { default: 'operation' }},
      ],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            let range = dateRange.value || ['', ''];

            let query = _objectSpread({
              startTime: range[0],
              endTime: range[1]
            }, search.value);

            query.settlementStatus = routeQuery.settlementStatus || search.value.settlementStatus;

            if (routeQuery.participateRole) {
              query.participateRole = routeQuery.participateRole;
            }

            if (routeQuery.participateId) {
              query.participateId = routeQuery.participateId;
              query.isEntry = 1;
            }

            if (routeQuery.withdrawStatus) {
              query.withdrawStatus = routeQuery.withdrawStatus;
            }

            query.orderStatus = query.orderStatus.join();
            return new Promise(resolve => {
              let params = _objectSpread({
                page: page.currentPage,
                pageSize: page.pageSize
              }, query);

              Axios.get('/admin/split/record/list.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                statistic.value = res.data.data.count || {};
                total.value = res.data.data.total;
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });

    function reset() {
      search.value = {
        supplierId: '',
        orderCodeSplit: '',
        participateRole: '',
        participateName: '',
        settlementStatus: '',
        orderStatus: ['40', '6'],
        settlementType: ''
      };
      dateRange.value = [lastMonthStartDate, lastMonthEndDate];
      table.value.commitProxy('reload');
    }

    const supplierList = ref([]);

    function getSupplierList() {
      // let params = { isFilterManufacture: 1 }
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    const detailModal = ref({
      show: false,
      recordId: ''
    });

    function exportHandle() {
      let range = dateRange.value || ['', ''];

      let query = _objectSpread({
        startTime: range[0],
        endTime: range[1]
      }, search.value);

      query.orderStatus = query.orderStatus.join();
      exportForAsync(_objectSpread({
        fileName: '分账流水',
        modularflag: 'splitRecordList',
        methodName: '/admin/split/record/export.json',
        count: total.value
      }, query));
    }

    const orderStateList = ref([]);
    getOrderStateList().then(res => {
      orderStateList.value = res.data.orderStateList;
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_input, {
        modelValue: search.value.orderCodeSplit,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.orderCodeSplit = $event),
        placeholder: "请输入订单编号"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: search.value.supplierId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.value.supplierId = $event),
        placeholder: "请选择",
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_select, {
        modelValue: search.value.orderStatus,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.value.orderStatus = $event),
        multiple: "",
        "collapse-tags": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderStateList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.orderStateDes,
            value: item.orderStateCode,
            key: item.orderStateCode
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_select, {
        modelValue: search.value.participateRole,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => search.value.participateRole = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "平台",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "商业公司",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "销售团队",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "团队成员（下单人）",
          value: "4"
        }), _createVNode(_component_el_option, {
          label: "团队成员（分账受益人）",
          value: "5"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_input, {
        modelValue: search.value.participateName,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => search.value.participateName = $event),
        placeholder: "请输入"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_select, {
        modelValue: search.value.settlementType,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => search.value.settlementType = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "人工",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "自动",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_select, {
        modelValue: search.value.settlementStatus,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => search.value.settlementStatus = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "未结算",
          value: "0"
        }), _createVNode(_component_el_option, {
          label: "已结算",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "部分结算",
          value: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[8] || (_cache[8] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_20]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_21]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, "￥" + _toDisplayString(statistic.value.totalSplitAmount || 0), 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, "￥" + _toDisplayString(statistic.value.totalSettlementAmount || 0), 1)])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createVNode(_component_el_button, {
        type: "primary",
        onClick: exportHandle
      }, {
        default: _withCtx(() => [_hoisted_32]),
        _: 1
      })])]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        splitSequenceNumber: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          style: {
            "color": "#409eff"
          },
          onClick: $event => detailModal.value = {
            show: true,
            recordId: row.recordId
          }
        }, _toDisplayString(row.splitSequenceNumber), 9, _hoisted_33)]),
        settlementStatusName: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.settlementStatusName), 1), row.settlementAmount ? (_openBlock(), _createElementBlock("span", _hoisted_34, "(￥" + _toDisplayString(row.settlementAmount) + ")", 1)) : _createCommentVNode("", true)]),
        orderStatusName: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.orderStatusName), 1), row.isOutStockError ? (_openBlock(), _createElementBlock("span", _hoisted_35, "（异常）")) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(DetailModal, {
        modelValue: detailModal.value.show,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => detailModal.value.show = $event),
        recordId: detailModal.value.recordId
      }, null, 8, ["modelValue", "recordId"])]);
    };
  }

};